import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalProjectContactDirectoryDbTableDefinition extends DbTableDefinition {
  tableName = 'local_projectContactDirectory';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
     sourcetype INTEGER,
     label TEXT NOT NULL,
     branchid BIGINT(20),
     personid BIGINT(20),
     functiongroupid BIGINT(20),
     servicejobid BIGINT(20),
     sortorder INTEGER,
     notes TEXT,
     createdtstamp BIGINT(20),
     updatedtstamp BIGINT(20),
     personlabel TEXT,
     personphone TEXT,
     personemail TEXT,
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(37, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);

    // employeeid was added after this table may already have been created on
    // a device during this feature's development - use the safe ALTER
    // migration approach rather than editing tableStructure directly.
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({ table: this.tableName, col: 'employeeid', type: 'BIGINT(20)' });
    } else {
      this.updateStatements.set(43, [
        `ALTER TABLE ${this.tableName} ADD COLUMN employeeid BIGINT(20);`,
      ]);
    }
  }
}
